export const looseFocus = () => {
    if (typeof document !== `undefined`) {
        document.activeElement.blur();
    }
}